module.exports = __webpack_public_path__ + "static/media/pju1(1).e5479e06.png";